export var getDimensions = function getDimensions(target) {
  if (typeof target === 'string') {
    return document.getElementById(target).getBoundingClientRect();
  }

  return target.getBoundingClientRect();
};
export var closest = function closest(target, parent) {
  if (!target) return false;
  return parent === target || closest(target.parentNode, parent);
};
export var addResizeEndListener = function addResizeEndListener(element, callback) {
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(callback);
    resizeObserver.observe(element);
    return resizeObserver;
  }

  if (!('ResizeObserver' in window)) {
    var resizeTimeout = null;

    var resizeHandler = function resizeHandler() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(callback, 400);
    };

    window.addEventListener('resize', resizeHandler);
    return resizeHandler;
  }

  return null;
};
export var removeResizeEndListener = function removeResizeEndListener(element, listener) {
  if ('ResizeObserver' in window) {
    listener.unobserve(element);
  }

  if (!('ResizeObserver' in window)) {
    window.removeEventListener('resize', listener);
  }
};